import { Divider } from "@mui/material";
import { customDividerStyle } from "./CustomDivider.style";

function CustomDivider() {
  const { dividerStyle } = customDividerStyle;
  return <Divider orientation="vertical" sx={dividerStyle} />;
}

export default CustomDivider;
